<template>
  <transition name="el-fade-in-linear">
    <div v-show="dialogVisible" class="popContainer indiv-pop">
      <div class="indiv-pop-center">
        <span
          class="indiv-pop-close iconfont icon-close_round_fill_bold"
          role="button"
          aria-label="关闭"
          @click="onClose"
        ></span>
        <div class="indiv-pop-box plan-pop">
          <h3 class="plan-pop__hd">购买服务</h3>
          <p v-if="showTrialTip" class="plan-pop__tip">本次购买将赠送剩余试用天数</p>
          <div class="plan-pop__body">
            <div class="plan-pop__grid" role="radiogroup" aria-label="选择套餐">
              <div
                v-for="plan in plans"
                :key="plan.years"
                class="plan-pop__card"
                role="radio"
                :aria-checked="plan.years === selectedYears"
                :class="{ 'plan-pop__card--active': plan.years === selectedYears }"
                tabindex="0"
                @click="selectPlan(plan.years)"
                @keydown.enter.prevent="selectPlan(plan.years)"
                @keydown.space.prevent="selectPlan(plan.years)"
              >
                <span class="plan-pop__tag">限时特价</span>
                <div class="plan-pop__main">
                  <span class="plan-pop__name">{{ plan.label }}</span>
                  <div class="plan-pop__prices">
                    <span class="plan-pop__price"
                      ><em>¥</em> {{ formatPrice(plan.price) }}</span
                    >
                    <!-- <span class="plan-pop__origin"
                      >¥ {{ formatPrice(plan.originPrice) }}</span
                    > -->
                  </div>
                </div>
                <div class="plan-pop__daily">低至{{ plan.daily }}元每天</div>
              </div>
            </div>
            <div class="plan-pop__benefits">
              <p class="plan-pop__benefits-hd">
                <img class="plan-pop__benefits-icon" :src="vipIcon" alt="" />
                <span class="plan-pop__benefits-text">{{ benefits.title }}</span>
              </p>
              <ul class="plan-pop__benefits-list">
                <li v-for="(item, index) in benefits.items" :key="index">
                  <i class="iconfont icon-duigou plan-pop__check"></i>
                  <span>{{ item }}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="plan-pop__foot">
            <button
              type="button"
              class="plan-pop__btn"
              :disabled="!verified"
              @click="onConfirm"
            >
              <span class="plan-pop__btn-price">¥ {{ selectedPrice }}</span>
              <span class="plan-pop__btn-text">立即购买</span>
            </button>
            <p v-if="!verified" class="plan-pop__hint">
              购买正式服务前请先进行
              <a href="javascript:;" @click.prevent="$emit('realname')"
                >实名认证 ></a
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import vipIcon from "./img/vip.png";
import { PLANS, DEFAULT_PLAN_YEARS, BENEFITS } from "./config";

export default {
  name: "PlanSelectDialog",

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    verified: {
      type: Boolean,
      default: false,
    },
    showTrialTip: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      // 当前仅开放一年套餐（两年/三年/四年见 config.js 注释）
      plans: PLANS,
      benefits: BENEFITS,
      selectedYears: DEFAULT_PLAN_YEARS,
      vipIcon,
    };
  },

  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },

    selectedPlan() {
      return (
        this.plans.find((item) => item.years === this.selectedYears) ||
        this.plans[0]
      );
    },

    selectedPrice() {
      return this.formatPrice(this.selectedPlan.price);
    },
  },

  watch: {
    visible(val) {
      if (val) {
        this.selectedYears = DEFAULT_PLAN_YEARS;
      }
    },
  },

  methods: {
    formatPrice(value) {
      const num = Number(value);
      if (Number.isNaN(num)) {
        return value;
      }
      return num.toLocaleString("zh-CN");
    },

    selectPlan(years) {
      this.selectedYears = years;
    },

    onClose() {
      this.dialogVisible = false;
      this.$emit("close");
    },

    onConfirm() {
      if (!this.verified) {
        return;
      }
      const plan = this.plans.find((item) => item.years === this.selectedYears);
      if (!plan) {
        return;
      }
      this.$emit("confirm", { ...plan });
    },
  },
};
</script>
<style scoped src="./purchase-service.css">
</style>



// WEBPACK FOOTER //
// src/view/user/purchaseService/PlanSelectDialog.vue